<template>
  <el-dialog v-el-drag-dialog
             :visible.sync="dialogVisible"
             :close-on-click-modal="false"
             title="打印标签"
             top="1vh"
             height="600px">
    <div id="printPurchaseLabelContent">
      <div v-for="(info,index) in labelList" :key="index" id="printPurchaseLabelCards"
           class="prevent-page-break-inside">
        <table style="width: 100%;" cellpadding="0" cellspacing="0">
          <tr>
            <td colspan="3" style="text-align: center;"><span
                style="font-size: 12px;font-weight: bold;">{{info.supplier}}</span></td>
          </tr>
          <tr>
            <td>物料代码</td>
            <td colspan="2"><span style="font-size: 14px;font-weight: bold;">{{info.materialNo}}</span></td>
          </tr>
          <tr>
            <td>物料名称</td>
            <td colspan="2"><span style="font-size: 12px;font-weight: bold;">{{info.materialName}}</span></td>
          </tr>
          <tr>
            <td>规格型号</td>
            <td colspan="2"><span style="font-weight: bold;font-size: 12px;">{{info.specification}}</span></td>
          </tr>
          <tr>
            <td>生产日期</td>
            <td><span>{{info.productionDate}}</span></td>
            <td style="width: 117px" rowspan="4">
              <div class="ewm" :id="(() => 'barCodeP1_'+info.pkid)()"/>
            </td>
          </tr>
          <tr>
            <td>有效期</td>
            <td><span>{{info.expirationDate}}</span></td>
          </tr>
          <tr>
            <td>皮重</td>
            <td><span>{{info.tareQuantity}}</span></td>
          </tr>
          <tr>
            <td>采购单号</td>
            <td><span>{{info.purchaseOrderNo}}</span></td>
          </tr>
          <tr>
            <td>备注</td>
            <td colspan="2"><span>{{info.note}}</span></td>
          </tr>
          <tr>
            <td colspan="3" style="text-align: center;"><span
                style="font-size: 16px;font-weight: bold;">{{info.showCode}}</span></td>
          </tr>
        </table>
      </div>
    </div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
      <el-button type="primary" v-print="printOption" @click="print">打印</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import QRCode from "qrcodejs2";

  export default {
    data() {
      return {
        dialogVisible: false,
        // productInfo: {},
        labelList: [],
        ids: [],
        printOption: {
          id: "printPurchaseLabelContent",
          preview: false,
          popTitle: "打印",
          previewPrintBtnLabel: "打印",
          clickMounted() {
          },
        },
      };
    },
    methods: {
      open(data) {
        this.ids = [];
        this.labelList = [];
        this.labelList = JSON.parse(JSON.stringify(data));
        this.dialogVisible = true;

        this.$nextTick(() => {
          this.labelList.forEach((item) => {
            this.ids.push(item.pkid);
            document.getElementById("barCodeP1_" + item.pkid).innerHTML = "";
            this.bindQRCode(item.serialNumber, item.pkid);
          });
        });
      },

      bindQRCode(row, id) {
        let text = row;
        new QRCode(document.getElementById("barCodeP1_" + id), {
          text: text,
          width: 80,
          height: 80,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
        });
      },

      print() {
        // this.$http.get("basic", `taskDispatchBills/updatePrint/${this.ids}`).then(() => {});
        return false;
      },
    },
  };
</script>
<style lang="scss">
#printPurchaseLabelCards {
  width: 98mm;
  height: 58mm;
  margin: 1.5mm auto;
  font-size: 10px;

  table {
    width: 100%;
    height: 100%;
    border-right: 1px solid #111;

    tr {

      &:first-child td {
        border-top: 1px solid #111;
      }

      td {
        border-bottom: 1px solid #111;
        border-left: 1px solid #111;
        font-size: 10px;
        padding-left: 2px;
        min-width: 46px;

        .ewm {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: -5px;
        }
      }
    }

  }
}

@media print {
  .prevent-page-break-inside {
    page-break-inside: avoid;
  }

  #printPurchaseLabelCards {
    margin: 0;
  }

  @page {
    padding: 1mm;
  }
}
</style>
